<template>
  <div class="feedback-wrap">
    <TopPanel>意见反馈</TopPanel>
    <div class="filters">
      <div class="feed-title">请选择反馈类型</div>
      <div class="order-status-row">
        <order-filter
          class="switch"
          :list="feedbackList"
          @change="changeFeedbackList"
        ></order-filter>
      </div>
    </div>
    <textarea placeholder="请告诉我们哪里还需要完善，您的支持和反馈是我们前进的动力" v-model="feedContent"></textarea>
    <div class="sumit-wrap">
      <div class="sumit" @click="setFeedbackFun()">提交</div>
    </div>
  </div>
</template>

<script>
import OrderFilter from '@/components/Mine/OrderFilter'
import TopPanel from '@/components/Mine/TopPanel'
import { setFeedback } from '@/api/mine'
export default {
  name: 'Feedback',
  props: {},
  components: { TopPanel, OrderFilter },
  data() {
    return {
      feedbackList: [
        { name: '问题反馈', index: 0, value: 2 },
        { name: '产品建议', index: 1, value: 3 },
        { name: '其他', index: 2, value: 1 }
      ],
      orderList: [],
      feedStatus: 1,
      feedContent: ''
    }
  },
  created() {},
  methods: {
    changeFeedbackList(value) {
      this.feedStatus = value
    },
    async setFeedbackFun() {
      var data = {
        type: this.feedStatus,
        content: this.feedContent
      }
      const res = await setFeedback(data)
      if (res.result.code === 0) {
        this.feedContent = ''
        this.$alert('感谢您的反馈', '', {
          confirmButtonText: '确定',
          center: true,
          showClose: false
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.sumit-wrap {
  display: flex;
  justify-content: flex-end;
  margin-right: 30px;
}
.sumit {
  width: 120px;
  height: 40px;
  background-color: #046bcc;
  border-radius: 5px;
  font-size: 14px;
  line-height: 40px;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}
textarea {
  box-sizing: border-box;
  width: 768px;
  height: 160px;
  background-color: #fafafa;
  margin: 0 auto;
  outline: none;
  resize: none;
  border: none;
  padding: 20px;
  color: #262626;
  font-size: 14px;
  margin-bottom: 30px;
}
.feedback-wrap {
  width: 828px;
  height: 600px;
  background-color: #ffffff;
  border: solid 1px #ebebeb;
  margin-left: 30px;
  margin-top: 0px;
  display: flex;
  flex-direction: column;
}
.filters {
  width: 768px;
  height: 103px;
  display: flex;
  flex-direction: column;
  .feed-title {
    color: #262626;
    font-size: 14px;
    margin: 30px 0 0 30px;
  }
}
.order-status-row {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  height: 26px;
  margin-top: 20px;
  margin-left: 20px;
  position: relative;
}
</style>
